<ng-container *ngIf="hourRates$ | async as data">
    <div class="dropdown" [class.open]="_open" [class.inactive]="_active | not">
        <div class="selected" (click)="_toggleOpen()">
            <div class="item">
                <div class="rate-info">
                    <div class="description">{{ data[_selectedIndex]?.description }}</div>
                    <div class="rate">{{data[_selectedIndex]?.value | currency:'EUR' }}</div>
                </div>
            </div>
            <div class="opener">
                <i class="fas" [class.fa-arrow-down]="_open | not" [class.fa-arrow-up]="_open"></i>
            </div>
        </div>
        <div class="dropdown-container" [class.open]="_open">
            <ng-container *ngFor="let rate of data; let i = index">
                <div class="item" (click)="_handleClickHourlyRate(i)">
                    <div class="color-code" [class.selected]="i | equals: _selectedIndex"></div>
                    <div class="rate-info">
                        <div class="description">{{ rate.description }}</div>
                        <div class="rate">{{ rate.value | currency:'EUR' }}</div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>